var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footerAll"},[_c('p',{staticClass:"footMusicWOW"},[_vm._v("\n      2017MusicWOW音乐窝 Inc.All rights reseved. 广州市乐沃信息科技有限公司\n      版权所有 "),_c('a',{attrs:{"href":"http://beian.miit.gov.cn"}},[_vm._v("粤ICP备18022034号")])]),_c('p',{staticClass:"footMusicWOW"},[_vm._v("提示：投资有风险 加盟需谨慎")])])])
}]

export { render, staticRenderFns }